<!-- 选择公立年级 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="grade" type="grade" clearable/>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-年级选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '当前公立年级：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const grade = useQuery('grade', props.value);

    return {
      grade,
    };
  },
};
</script>
